import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { queryClient } from '@/lib/queryClient';
import { AuthProvider } from '@/auth/AuthContext';
import { RequireAuth } from '@/auth/RequireAuth';
import { AppShell } from '@/components/AppShell';
import { LoginPage } from '@/pages/Login';
import { AuthCallbackPage } from '@/pages/AuthCallback';
import { DashboardPage } from '@/pages/Dashboard';
import { ProjectsPage } from '@/pages/Projects';
import { ProjectDetailPage } from '@/pages/ProjectDetail';
import { ProjectChatPage } from '@/pages/ProjectChat';
import { SettingsPage } from '@/pages/Settings';
import { SettingsProjectsPage } from '@/pages/SettingsProjects';
import { SettingsUsagePage } from '@/pages/SettingsUsage';
import { SettingsAccountsPage } from '@/pages/SettingsAccounts';
import { InboxPage } from '@/pages/Inbox';
import { DraftsPage } from '@/pages/Drafts';
import { RenovationPage } from '@/pages/Renovation';
import { BriefsPage } from '@/pages/Briefs';
import { CalendarPage } from '@/pages/Calendar';
import { Placeholder } from '@/pages/Placeholder';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <AppShell />
                </RequireAuth>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="inbox" element={<InboxPage />} />
              <Route path="drafts" element={<DraftsPage />} />
              <Route path="projects" element={<ProjectsPage />} />
              <Route path="projects/:id" element={<ProjectDetailPage />} />
              <Route path="projects/:id/chat" element={<ProjectChatPage />} />
              <Route path="projects/:id/renovation" element={<RenovationPage />} />
              <Route path="briefs" element={<BriefsPage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="voice" element={<Placeholder title="Voice" phase="Phase 6" />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="settings/projects" element={<SettingsProjectsPage />} />
              <Route path="settings/usage" element={<SettingsUsagePage />} />
              <Route path="settings/accounts" element={<SettingsAccountsPage />} />
            </Route>
          </Routes>
        </AuthProvider>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: 'hsl(var(--card))',
              color: 'hsl(var(--card-foreground))',
              border: '1px solid hsl(var(--border))',
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
